import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=1c23b776&scoped=true&"
import script from "./SessionCard.vue?vue&type=script&lang=ts&"
export * from "./SessionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=1c23b776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23b776",
  null
  
)

export default component.exports